<template>
  <div>
    
    <div class="row">
      <div class="col-md-12">
        <b-button variant="primary" class="btn btn-primary float-right mb-1" v-on:click="add()">
          <i class="fa fa-plus"/>&nbsp;Lägg till
        </b-button>
      </div>
    </div>
    <b-card>

      <div slot="header">
        Företag
        <div class="card-header-actions">
          <b-spinner v-if="loading" class="mr-1" type="border" small />
        </div>
      </div>        
      <table class="table table-striped table-hover">
        <thead>
          <tr class="d-flex">
            <th class="col-8 col-lg-11">Namn</th>
            <th class="col-4 col-lg-1 text-center">Radera</th>
          </tr>
        </thead>
        <tbody>
          <tr class="d-flex" v-for="company in companies" :key="company.id" style="cursor:pointer">
            <td class="col-8 col-lg-11" v-on:click="edit(company)">{{company.name}}</td>
            <td class="col-4 col-lg-1 text-center">
                <i class="fa fa-trash-o fa-lg" v-on:click="deleteCompany(company)"></i>
            </td>
          </tr>
        </tbody>
      </table>
    </b-card>

    <b-modal id="deleteConfirmModal" ref="deleteConfirmModal" title="Radera" @ok="deleteCompanyConfirm">
      <p class="my-4" v-if="selectedCompany">Är du säker på att du vill radera '{{selectedCompany.name}}'?</p>
    </b-modal>
  </div>
</template>

<script>
import { companyService } from '../../shared/services';

export default {
  data() {
    return {
      loading:false,
      companies: null,
      selectedCompany: null
    };
  },    
  mounted() {
    this.loading = true;
    companyService.getAll().then(p => {
      this.companies = p;
      this.loading = false;
    }).catch(() => {
        this.ShowToast("Fel","Ett okänt fel uppstod när företag skulle hämtas", "danger");
        this.loading = false;
      })
  },
  methods: {
    edit: function(company) {
      this.$router.push({ path: `/administration/companies/${company.id}` });
    },
    add: function() {
      this.$router.push({ path: `/administration/companies/0` });
    },
    deleteCompany(company) {
      this.selectedCompany = company;
      this.$refs.deleteConfirmModal.show();
    },
    deleteCompanyConfirm() {
      if(!this.selectedCompany) return;

      companyService.deleteById(this.selectedCompany.id).then(() => {
        this.companies.splice(this.companies.indexOf(this.selectedCompany), 1);
        this.ShowToast("Raderad","Företaget raderades","success");
      }).catch(p => {
          if(p.status == 409) {
            this.ShowToast("Fel","Företaget används och kan därför inte raderas","danger");
            return;
          }
          this.ShowToast("Fel","Ett okänt fel uppstod när företaget skulle raderas","danger");
      })
    }
  }
};
</script>

<style>
</style>
